import React from "react";

const ManageSectionConditions = () => {
  return (
    <div className="utah-design-system page-container">
      <h3>Manage Section Conditions</h3>
    </div>
  );
};

export default ManageSectionConditions;
